export default "__VITE_ASSET__Bw_E7P6z__"